import { frArmyGreenPalettes } from "../../../../Posts/01-paletas/02-paleta-verde/06-verde-militar/palettes";
import * as React from 'react';
export default {
  frArmyGreenPalettes,
  React
};